import { Injectable } from '@angular/core';
import { StorageEngine } from './storage-engine.interface';

/** Browser `sessionStorage` — cleared when the tab closes. */
@Injectable({ providedIn: 'root' })
export class SessionStorageService implements StorageEngine {
  getItem(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
